var React = require('react');

function YourMomsHouseRound (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"#CE1126","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 7L9 14V27H27V14L18 7ZM22.2856 19.7144L21.4285 20.5713L17.9999 24L14.5714 20.5713L13.7167 19.7168L13.7143 19.7144C12.7675 18.7676 12.7675 17.2324 13.7143 16.2856C14.661 15.3389 16.196 15.3389 17.1428 16.2856L17.9999 17.1428L18.849 16.2937L18.857 16.2856C19.8038 15.3389 21.3388 15.3389 22.2856 16.2856C23.2323 17.2324 23.2323 18.7676 22.2856 19.7144Z","fill":"white","key":1})]);
}

YourMomsHouseRound.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = YourMomsHouseRound;

YourMomsHouseRound.default = YourMomsHouseRound;
